import React, { useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import Header from '../Header';

const StyledContainer = styled.div``;

const SettingsLayout = () => {
  const headerRef = useRef(null);
  const headerSpaceElemRef = useRef(null);

  const handleResize = () => {
    if (!isMobile && headerSpaceElemRef.current && headerRef.current) {
      headerSpaceElemRef.current.style.marginTop = headerRef.current.getBoundingClientRect().height + 'px';
    }
  };

  useEffect(() => {
    if (headerSpaceElemRef.current && headerRef.current) {
      headerSpaceElemRef.current.style.marginTop = headerRef.current.getBoundingClientRect().height + 'px';
    }

    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, []);

  return (
    <StyledContainer>
      <Header containerRef={headerRef} />
      <div id="headerSpaceElem" ref={headerSpaceElemRef}></div>
      <Outlet />
    </StyledContainer>
  );
};

export default SettingsLayout;
